import BaseEntityService from 'vue-core/services/BaseEntityService';
import env from 'environment';

class UserService
    extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + '/users'
    });
  }
}

const service = new UserService();

export default service;
